import React from 'react'
import styled from 'styled-components'
// import { trash, check_mark } from '../../assets'

const TableHeader = ({ resourceTitle, authorName, resourceUrl, resourceDesc, datePublished, 
newpaperName, }) => {
  return (
    <Container>
        <div>
            <ul>
                <li>{resourceTitle || newpaperName }</li>
                <li>{authorName}</li>
                <li>{resourceUrl}</li>
                <li>{resourceDesc}</li>
                {/* <li>{authorName}</li> */}
                {/* <li>{resourceUrl}</li> */}
                
                <li>
                    <div></div>
                </li>
            </ul>
        </div>
        
        
    </Container>
  )
}

const Container = styled.section`
    display: flex;
    width: 100%;
    margin-top: 2rem;
    background-color: orange;

    & > div {
        width: 100%;
        & > ul {
            
            width: 100%;
        display: flex;
        justify-content: space-between;
        width: 100%;
        background-color: #ebeced;
        border-bottom: 1px solid;

        &  li {
            font-size: 12px;
            color: #667085;
            padding: 13px;
            flex: 1;
            font-weight: bold;
            /* text-align: center; */

            & > ul {
                border-bottom: none;

                &  li {
                    padding: 0;
                }
            }
        }
    }

    }
    
`

export {TableHeader}